/* 🤖 this file was generated by svg-to-ts */
export var spxIconAuditBy = {
    name: 'audit_by',
    data: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 2c-4.42 0-8 2.24-8 5v3h16v-3c0-2.76-3.58-5-8-5Z\"/></svg>"
};
